import { replacePlaceholder } from '@/common/converter/utils/replace-placeholder'
import { snakeToCamel } from '@/common/converter/utils/snake-to-camel'

/**
 * SingleBanner 용 Note 컬러 변환
 * @param source
 * @param target
 * @returns {string}
 */
export const convertNote = (source = {}, target = {}) => {
  const { contextProperty = {} } = source
  const bgColor = snakeToCamel(contextProperty?.bgColor) ?? ''

  return replacePlaceholder(bgColor, target)
}
